import { TranslateResult } from 'vue-i18n';

import { AgentStatus } from '@/types';
import { AGENT_STATUS, AGENT_STATUS_LABEL } from '@/constants';

/**
 * Get label based on agents "statusData" property.
 * Legacy "busyReason" is also supported.
 */
export const getStatusLabel = (options: {
  data: AgentStatus & { busyReason?: string; };
  $t: (key: string) => TranslateResult;
}) => {
  const { data, $t } = options;

  const status = data.status || AGENT_STATUS.OFFLINE;
  if (status !== AGENT_STATUS.BUSY) {
    return data.label || $t(AGENT_STATUS_LABEL[status]) as string;
  }

  return data.label || data.busyReason || $t(AGENT_STATUS_LABEL[status]) as string;
};
